(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artetribe-3d-guide"]) return;
  try {
    
  (() => {
    const initGuide = (root) => {
      if (!root || root.dataset.atGuideReady === 'true') return;
      root.dataset.atGuideReady = 'true';

      const links = [...root.querySelectorAll('.at-reading-rail a')];
      const sections = links
        .map((link) => root.querySelector(link.getAttribute('href')))
        .filter(Boolean);

      if (!links.length || !sections.length || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => {
            const active = link.getAttribute('href') === `#${entry.target.id}`;
            link.classList.toggle('is-active', active);
            if (active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-20% 0px -65% 0px' });

      sections.forEach((section) => observer.observe(section));
    };

    document.querySelectorAll('[data-at-guide]').forEach(initGuide);
    document.addEventListener('shopify:section:load', (event) => {
      initGuide(event.target.querySelector('[data-at-guide]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
